/* eslint-disable */

import jQuery from 'jquery';

/**
 * A simple wrapper around the Square object.
 */
export default class WebPayments {
	constructor( formId, applicationId, locationId ) {
		this.formId = formId;
		this.applicationId = applicationId;
		this.locationId = locationId;
		this.card = null;
		this.payments = null;
	}

	/**
	 * @function getPaymentsApi
	 * @description Initializes and retrieves a Payments object from the Square SDK.
	 *
	 * @since 1.7
	 *
	 * @return {object} The Payments API object.
	 */
	getPaymentsApi() {
		if ( ! window.Square ) {
			throw new Error( 'Square.js failed to load properly' );
		}

		if ( this.payments === null ) {
			this.payments = window.Square.payments( this.applicationId, this.locationId );
		}

		return this.payments;
	}

	/**
	 * @function getCard
	 * @description Returns the card object if it already exists, otherwise initiates it.
	 *
	 * @since 1.7
	 *
	 * @param {object} styleObject An object that contains styling properties for the card.
	 *
	 * @return {Promise<object>}
	 */
	async getCard( styleObject ) {
		if ( this.payments === null ) {
			this.getPaymentsApi();
		}

		if ( this.card !== null ) {
			return this.card;
		}

		try {
			if ( styleObject ) {
				this.card = await this.payments.card( {
					style: styleObject,
				} );
			} else {
				this.card = await this.payments.card();
			}
			return this.card;
		} catch ( e ) {
			throw new Error( 'Could not get card from payment API: ' + e.toString() );
		}
	}

	/**
	 * @function getTokenizeCard
	 * @description Tokenize the card object.
	 *
	 * @since 1.7
	 *
	 * @return {Promise<boolean | object>}
	 */
	async getTokenizeCard() {
		if ( this.card === null || this.card.attached === false ) {
			throw new Error( 'Can not tokenize card that is not attached' );
		}

		try {
			this.tokenizedCard = await this.card.tokenize();
			return this.tokenizedCard;
		} catch ( e ) {
			throw new Error( 'Could not tokenize card: ' + e.toString() );
		}
	}

	/**
	 * @param  configuration
	 * @function reConfigureCard
	 * @description Re Configures the card after it has been initialized and attached.
	 *
	 * @since 1.7
	 *
	 * @return {Promise<boolean | object>}
	 */
	reConfigureCard( configuration ) {
		if ( this.card === null || this.card.attached === false ) {
			return;
		}

		return this.card.configure( configuration );
	}
}
